import { actions } from 'react/api/actions/recoverPassword';
import { fromJS } from 'immutable';

const {
  fillMessage,
  recoverPasswordOnChange,
  requestChangePassword,
  requestChangePasswordFailed,
  requestChangePasswordSuccess,
  resetState
} = actions;

const initialState = fromJS({
  password: {
    oldPass: '',
    newPass: '',
    confirmPass: '',
    type: 'password',
    hintsValidated: false
  },
  success: false,
  loading: false,
  errorMessage: ''
});

export default (state = initialState, action) => {
  if (recoverPasswordOnChange === action.type) {
    const { id, value } = action.payload;
    return state.mergeIn(['password', id], value);
  }

  if ([requestChangePasswordFailed].includes(action.type)) {
    const messageObject = action.payload;
    const { message } = messageObject.errorMessage;

    return state.merge({
      errorMessage: message,
      loading: false
    });
  }

  if (requestChangePassword === action.type) {
    return state.merge({
      errorMessage: '',
      loading: true
    });
  }

  if (requestChangePasswordSuccess === action.type) {
    return state.merge({
      success: true,
      loading: false
    });
  }

  if (fillMessage === action.type) {
    return state.mergeIn(['errorMessage'], action.payload);
  }

  if (resetState === action.type) {
    state = initialState;

    return state;
  }

  return state;
};
